/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import Moment from 'react-moment';

//----------------------------------------------------------------------//
// MATERIAL UI
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import FormButton from 'forms/components/controls/FormButton';

//----------------------------------------------------------------------//
// CSS
//----------------------------------------------------------------------//

import styles from './ElectroUseOriginal.module.scss';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

type TypeProps = {|
  field: Object,
  input: React.Node,
  type?: string,
  label?: string,
  altLabel?: string,
  setMode: Function,
  inEditMode: boolean,
|};

class ElectroUseOriginal extends React.Component<*> {
  originalValue: string = this.props.field.value;

  handleToggle = () => {
    const { field, setMode, inEditMode }: TypeProps = this.props;

    if (inEditMode) {
      field.set(this.originalValue);
    }

    setMode(!inEditMode);
  };

  render(): React.Node {
    const { field, input, type, label, altLabel, inEditMode }: TypeProps = this.props;

    return (
      <div className={`${styles['select-wrapper']} ${styles['is-flex']}`}>
        <div className={styles['value-field']}>
          {inEditMode ? (
            input
          ) : type && type === 'date' ? (
            <div className={styles['read-only']}>
              <Moment date={this.originalValue} format="MMMM DD, YYYY" />
            </div>
          ) : (
            <div className={styles['read-only']}>this.originalValue</div>
          )}
        </div>
        <FormButton isFlex={true}>
          <Button
            id={field.name}
            color="default"
            variant="outlined"
            onClick={() => {
              this.handleToggle();
            }}
          >
            <svg className="button-icon">
              <use xlinkHref="#icon-add" />
            </svg>
            {inEditMode ? label || 'Use original' : altLabel || 'Change'}
          </Button>
        </FormButton>
      </div>
    );
  }
}

export default observer(ElectroUseOriginal);
